/**
 * Filtragem local de opções — substitui fuse.js.
 * Normaliza acentuação e busca por substring case-insensitive no label.
 */

function normalize(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
}

export function filterOptions<T extends { label?: unknown; value?: unknown }>(
  options: T[],
  query: string,
): T[] {
  if (!query.trim()) return options
  const q = normalize(String(query))
  return options.filter((opt) => normalize(String(opt.label ?? '')).includes(q))
}
